import { PaletteOptions } from '@mui/material';
import { grey, orange, red } from '@mui/material/colors';

const WHITE = '#FFF';
const BLACK = '#1F1F1F';

export const palette: PaletteOptions = {
  primary: {
    main: '#FBC02D',
  },
  secondary: {
    main: grey[500],
  },
  info: { main: '#6393F2' },
  error: { main: '#E25345' },
  success: { main: '#509F4E' },
  warning: {
    light: orange[500],
    main: orange[700],
    dark: red[700],
  },
  // lowEmphasis: 'rgba(229, 229, 229, 1)',
  // mediumEmphasis: 'rgba(153, 153, 153, 1)',
  // highEmphasis: 'rgba(31, 31, 31, 1)',
  accent: {
    main: '#6393F2',
  },
  background: {
    membership: '#FAF7F2',
    inlineInfoCard: '#FEF1E5',
  },
  common: {
    black: BLACK,
  },
  watchdutyComplex: {
    main: '#F19437',
    contrastText: WHITE,
  },
};

export const darkPalette: PaletteOptions = {
  ...palette,
  primary: {
    ...palette.primary,
    main: WHITE,
    contrastText: BLACK,
  },
  secondary: {
    ...palette.secondary,
    main: grey[500],
    contrastText: WHITE,
  },
  background: {
    ...palette.background,
    default: BLACK,
    paper: grey[900],
  },
  text: {
    primary: grey[50],
    secondary: grey[400],
    disabled: grey[600],
  },
  action: {
    hover: 'rgba(255, 255, 255, 0.20)',
    focus: 'rgba(255, 255, 255, 0.20)',
  },
};
